const faqsSection = {
  heading: "Frequently Asked Questions",
  services: [
    {
      label: "1. What is WaveLight Plus bladeless LASIK surgery?",
      content:
        "WaveLight Plus is an AI-guided bladeless LASIK surgery that maps over 22,000 data points on your cornea to deliver a fully personalised laser vision correction surgery. It is FDA approved and performed at Amrit Hospitals, Chennai.",
    },
    {
      label: "2. Is WaveLight Plus a safe eye power correction surgery?",
      content:
        "Yes. WaveLight Plus is 100% safe and U.S. FDA approved. It is one of the most trusted forms of eye power correction surgery available today. 98% of patients at Amrit Hospitals achieve 20/20 vision or better.",
    },
    {
      label: "3. Can WaveLight Plus permanently remove my specs?",
      content:
        "Yes. WaveLight Plus is an advanced specs removal surgery that helps eligible patients become rid of specs and contact lenses by permanently reshaping the cornea",
    },
    {
      label: "4. How is WaveLight Plus different from standard LASIK?",
      content:
        "Unlike standard LASIK, WaveLight Plus is an advanced laser eye surgery that uses AI-powered 3D mapping and ray tracing to design a custom treatment plan. It achieves 20/15 or even 20/13 — beyond standard 20/20 vision.",
    },
    {
      label: "5. How long does laser vision correction surgery take?",
      content:
        "WaveLight Plus laser vision correction surgery takes under 15 seconds per eye. The full procedure including preparation is completed in under 30 minutes, and patients return home the same day.",
    },
    {
      label: "6. Who is a candidate for refractive eye surgery with WaveLight Plus?",
      content:
        "Patients aged 18+ with stable spectacle power for 12 months, adequate corneal thickness, and myopia, hyperopia, or astigmatism are typically eligible for WaveLight Plus refractive eye surgery. A pre-operative screening at Amrit Hospitals confirms eligibility.",
    },
    {
      label: "7. Who is a candidate for refractive eye surgery with WaveLight Plus?",
      content:
        "Most patients experience significantly improved vision within 24 hours of their bladeless LASIK surgery and can return to work and daily activities quickly. Full stabilisation occurs within 1–2 weeks.",
    },
  ],
};

export default faqsSection;
